import React from "react";
import { TranslationContext } from "components/TranslationProvider";

const useTranslation = () => React.useContext(TranslationContext);

export default useTranslation;
